import { FC, PropsWithChildren, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useUser } from '../authentication/hooks/user';
import { useCustomer } from '../graph/hooks/useCustomer';
import { useAddCustomContext } from './AppInsightsProvider';

export const CustomerInformationManager: FC<PropsWithChildren> = () => {
  const customer = useCustomer();
  const user = useUser();

  const addContext = useAddCustomContext();

  useEffect(() => {
    if (!customer) return;
    if (!user) return;
    addContext({
      Username: user.firstName + ' ' + user.lastName,
      Company: customer.data?.name,
      Industry: customer.data?.industry
    });
  }, [customer]);

  return <Outlet />;
};
